module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loaded) ? _c('div', {
    staticClass: "animated fadeIn setting-container step-container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 offset-md-2 alert-container-padding-zero"
  }, [_c('alertbar')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 offset-md-2 step-body"
  }, [_c('h4', {
    staticClass: "step-header"
  }, [_vm._v(_vm._s(_vm.$t('message.settings.title')))]), _vm._v(" "), _c('h6', [_vm._v(_vm._s(_vm.$t('message.settings.notification')))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "switch switch-text switch-pill switch-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.clinic.sms_confirmation),
      expression: "clinic.sms_confirmation"
    }],
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.clinic.sms_confirmation) ? _vm._i(_vm.clinic.sms_confirmation, null) > -1 : (_vm.clinic.sms_confirmation)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.clinic.sms_confirmation,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.clinic.sms_confirmation = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.clinic.sms_confirmation = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.clinic.sms_confirmation = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "On",
      "data-off": "Off"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.settings.notify_when_appointment')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-divider"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "switch switch-text switch-pill switch-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.clinic.sms_active),
      expression: "clinic.sms_active"
    }],
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.clinic.sms_active) ? _vm._i(_vm.clinic.sms_active, null) > -1 : (_vm.clinic.sms_active)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.clinic.sms_active,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.clinic.sms_active = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.clinic.sms_active = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.clinic.sms_active = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "On",
      "data-off": "Off"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.settings.notify_sms')))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-11"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "switch switch-text switch-pill switch-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.clinic.first_sms_reminder),
      expression: "clinic.first_sms_reminder"
    }],
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.clinic.first_sms_reminder) ? _vm._i(_vm.clinic.first_sms_reminder, null) > -1 : (_vm.clinic.first_sms_reminder)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.clinic.first_sms_reminder,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.clinic.first_sms_reminder = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.clinic.first_sms_reminder = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.clinic.first_sms_reminder = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "On",
      "data-off": "Off"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.settings.notify_before_one_day')) + " " + _vm._s(_vm.$t('message.settings.time')))]), _vm._v(" "), _c('vue-timepicker', {
    model: {
      value: (_vm.clinic.first_reminder_time_p),
      callback: function($$v) {
        _vm.clinic.first_reminder_time_p = $$v
      },
      expression: "clinic.first_reminder_time_p"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-11"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "switch switch-text switch-pill switch-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.clinic.second_sms_reminder),
      expression: "clinic.second_sms_reminder"
    }],
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.clinic.second_sms_reminder) ? _vm._i(_vm.clinic.second_sms_reminder, null) > -1 : (_vm.clinic.second_sms_reminder)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.clinic.second_sms_reminder,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.clinic.second_sms_reminder = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.clinic.second_sms_reminder = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.clinic.second_sms_reminder = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "On",
      "data-off": "Off"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.settings.notify_appointment_day')))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.settings.credit_remain')))]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.clinic.sms_credit))])]), _vm._v(" "), _c('div', {
    staticClass: "form-divider"
  })])]), _vm._v(" "), _c('h6', [_vm._v("การนัดหมาย Online")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "switch switch-text switch-pill switch-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.clinic.appointment_active),
      expression: "clinic.appointment_active"
    }],
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.clinic.appointment_active) ? _vm._i(_vm.clinic.appointment_active, null) > -1 : (_vm.clinic.appointment_active)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.clinic.appointment_active,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.clinic.appointment_active = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.clinic.appointment_active = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.clinic.appointment_active = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "On",
      "data-off": "Off"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Online Appointment")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "switch switch-text switch-pill switch-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.clinic.instant_booking),
      expression: "clinic.instant_booking"
    }],
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.clinic.instant_booking) ? _vm._i(_vm.clinic.instant_booking, null) > -1 : (_vm.clinic.instant_booking)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.clinic.instant_booking,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.clinic.instant_booking = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.clinic.instant_booking = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.clinic.instant_booking = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "On",
      "data-off": "Off"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Instant Booking")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "switch switch-text switch-pill switch-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.clinic.instant_booking_sms_confirmation),
      expression: "clinic.instant_booking_sms_confirmation"
    }],
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.clinic.instant_booking_sms_confirmation) ? _vm._i(_vm.clinic.instant_booking_sms_confirmation, null) > -1 : (_vm.clinic.instant_booking_sms_confirmation)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.clinic.instant_booking_sms_confirmation,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.clinic.instant_booking_sms_confirmation = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.clinic.instant_booking_sms_confirmation = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.clinic.instant_booking_sms_confirmation = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "On",
      "data-off": "Off"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("ส่ง SMS confirm เมื่อมี Instant Booking")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "switch switch-text switch-pill switch-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.clinic.forward_to_clinic_email),
      expression: "clinic.forward_to_clinic_email"
    }],
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.clinic.forward_to_clinic_email) ? _vm._i(_vm.clinic.forward_to_clinic_email, null) > -1 : (_vm.clinic.forward_to_clinic_email)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.clinic.forward_to_clinic_email,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.clinic.forward_to_clinic_email = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.clinic.forward_to_clinic_email = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.clinic.forward_to_clinic_email = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "On",
      "data-off": "Off"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.settings.new_appointment_fwd_to_mail')))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Emails อื่นๆ (สำหรับการรับแจ้งเตือนนัดหมาย)")]), _vm._v(" "), _c('doctor-single-input', {
    attrs: {
      "dataset": _vm.clinic.clinic_email,
      "description": _vm.$t('message.settings.email')
    },
    on: {
      "update:dataset": [function($event) {
        _vm.clinic.clinic_email = $event
      }, function (v) { return _vm.clinic.clinic_email = v; }]
    }
  }), _vm._v(" "), _c('doctor-array-input', {
    attrs: {
      "dataset": _vm.clinic.emails,
      "description": _vm.$t('message.settings.email')
    },
    on: {
      "update:dataset": [function($event) {
        _vm.clinic.emails = $event
      }, function (v) { return _vm.clinic.emails = v; }]
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-divider"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "switch switch-text switch-pill switch-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.clinic.auto_match_ehr_patient),
      expression: "clinic.auto_match_ehr_patient"
    }],
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.clinic.auto_match_ehr_patient) ? _vm._i(_vm.clinic.auto_match_ehr_patient, null) > -1 : (_vm.clinic.auto_match_ehr_patient)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.clinic.auto_match_ehr_patient,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.clinic.auto_match_ehr_patient = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.clinic.auto_match_ehr_patient = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.clinic.auto_match_ehr_patient = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "On",
      "data-off": "Off"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.settings.auto_create_patient')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-divider"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 form-group"
  }, [_c('button', {
    staticClass: "btn btn-store btn-lg",
    on: {
      "click": _vm.save
    }
  }, [_vm._v(_vm._s(_vm.$t('action_message.save')))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "btn btn-sm",
    slot: "loader"
  }, [_c('sync-loader', {
    attrs: {
      "size": "10px"
    }
  })], 1)])])])]), _vm._v(" "), _c('sweet-modal', {
    ref: "modal",
    attrs: {
      "icon": "success"
    }
  })], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8d80b2c6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/clinic/Setting.vue
// module id = 1041
// module chunks = 1